import React, { useRef } from "react";
import { Camera, ImagePlus, X } from "lucide-react";

// Volba zdroje fotek. Jedno tlačítko „Nahrát" a v overlayi teprve fotoaparát
// nebo galerie — dvě dlaždice přímo v mřížce fotek matou (vypadají jako fotky)
// a na desktopu je fotoaparát stejně k ničemu.
export default function NahratFotky({ onFiles, onClose }) {
  const fotoRef = useRef(null);
  const galerieRef = useRef(null);

  const vzit = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (files.length) { onFiles(files); onClose(); }
  };

  const Volba = ({ ikona: Ikona, popis, onClick, testid }) => (
    <button onClick={onClick} data-testid={testid}
      className="flex items-center gap-3 w-full px-4 py-3.5 rounded-card border border-line-strong hover:bg-inputbg text-left">
      <span className="h-10 w-10 rounded-icon bg-accent/10 flex items-center justify-center shrink-0">
        <Ikona size={19} className="text-accent" />
      </span>
      <span className="text-[13.5px] font-700 text-ink">{popis}</span>
    </button>
  );

  return (
    <div className="fixed inset-0 z-[70] flex items-end md:items-center justify-center" data-testid="nahrat-fotky">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full md:max-w-[420px] rounded-t-sheet md:rounded-card shadow-panel">
        <div className="px-5 py-4 border-b border-line-softer flex items-center justify-between">
          <h2 className="text-[15px] font-800 text-ink">Nahrát fotky</h2>
          <button onClick={onClose} className="text-muted hover:text-ink" data-testid="nahrat-close"><X size={20} /></button>
        </div>
        <div className="p-5 space-y-2">
          {/* `capture` otevře rovnou fotoaparát — na desktopu se chová jako
              běžný výběr souboru, proto je volba nabídnutá zvlášť. */}
          <Volba ikona={Camera} popis="Vyfotit" testid="nahrat-foto"
            onClick={() => fotoRef.current?.click()} />
          <Volba ikona={ImagePlus} popis="Vybrat z galerie" testid="nahrat-galerie"
            onClick={() => galerieRef.current?.click()} />
        </div>
        <input ref={fotoRef} type="file" accept="image/*" capture="environment" multiple
          className="hidden" onChange={vzit} data-testid="foto-input" />
        <input ref={galerieRef} type="file" accept="image/*" multiple
          className="hidden" onChange={vzit} data-testid="foto-input-galerie" />
      </div>
    </div>
  );
}
